/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

/* -------------------------------------------------------------------------- */
/* SVG paths                                                                   */
/* -------------------------------------------------------------------------- */

const ALERT_PATH =
  'M11.0395 14.0686C10.8417 14.0686 10.6484 14.1273 10.4839 14.2372C10.3195 14.347 10.1913 14.5032 10.1156 14.6859C10.04 14.8687 10.0201 15.0697 10.0587 15.2637C10.0973 15.4577 10.1926 15.6359 10.3324 15.7757C10.4723 15.9156 10.6504 16.0108 10.8444 16.0494C11.0384 16.088 11.2395 16.0682 11.4222 15.9925C11.6049 15.9168 11.7611 15.7887 11.871 15.6242C11.9809 15.4598 12.0395 15.2664 12.0395 15.0686C12.0395 14.8034 11.9342 14.5491 11.7466 14.3615C11.5591 14.174 11.3047 14.0686 11.0395 14.0686ZM21.7095 15.5386L13.6595 1.53863C13.3993 1.07215 13.0193 0.683589 12.5587 0.4131C12.0981 0.142611 11.5737 0 11.0395 0C10.5054 0 9.98092 0.142611 9.52033 0.4131C9.05973 0.683589 8.67971 1.07215 8.41952 1.53863L0.419518 15.5386C0.150314 15.9926 0.0056609 16.5097 0.000162801 17.0375C-0.0053353 17.5652 0.128516 18.0852 0.388204 18.5447C0.647892 19.0042 1.02422 19.3871 1.4792 19.6547C1.93418 19.9222 2.4517 20.065 2.97952 20.0686H19.0995C19.6316 20.0739 20.1554 19.9375 20.6174 19.6735C21.0794 19.4096 21.4629 19.0275 21.7285 18.5665C21.9941 18.1054 22.1324 17.582 22.129 17.05C22.1257 16.5179 21.9809 15.9963 21.7095 15.5386ZM19.9795 17.5386C19.8919 17.6946 19.764 17.8242 19.6092 17.9139C19.4544 18.0036 19.2784 18.0501 19.0995 18.0486H2.97952C2.80063 18.0501 2.62462 18.0036 2.46984 17.9139C2.31505 17.8242 2.18717 17.6946 2.09952 17.5386C2.01175 17.3866 1.96554 17.2142 1.96554 17.0386C1.96554 16.8631 2.01175 16.6906 2.09952 16.5386L10.0995 2.53863C10.1834 2.37483 10.3109 2.23736 10.468 2.14137C10.625 2.04538 10.8055 1.99459 10.9895 1.99459C11.1736 1.99459 11.354 2.04538 11.5111 2.14137C11.6681 2.23736 11.7956 2.37483 11.8795 2.53863L19.9295 16.5386C20.0287 16.6885 20.0857 16.8623 20.0945 17.0418C20.1033 17.2213 20.0636 17.3998 19.9795 17.5586V17.5386ZM11.0395 6.06863C10.7743 6.06863 10.5199 6.17399 10.3324 6.36152C10.1449 6.54906 10.0395 6.80341 10.0395 7.06863V11.0686C10.0395 11.3338 10.1449 11.5882 10.3324 11.7757C10.5199 11.9633 10.7743 12.0686 11.0395 12.0686C11.3047 12.0686 11.5591 11.9633 11.7466 11.7757C11.9342 11.5882 12.0395 11.3338 12.0395 11.0686V7.06863C12.0395 6.80341 11.9342 6.54906 11.7466 6.36152C11.5591 6.17399 11.3047 6.06863 11.0395 6.06863Z';

const ALERT_FILLED_PATH =
  'M7.00808 1.22337C7.92561 -0.407791 10.2741 -0.407791 11.1916 1.22337L17.888 13.128C18.7879 14.7279 17.6318 16.7047 15.7962 16.7047H2.40349C0.567911 16.7047 -0.588203 14.7279 0.311713 13.128L7.00808 1.22337ZM10.2998 13.1048C10.2998 13.7675 9.7625 14.3048 9.09976 14.3048C8.43701 14.3048 7.89976 13.7675 7.89976 13.1048C7.89976 12.442 8.43701 11.9048 9.09976 11.9048C9.7625 11.9048 10.2998 12.442 10.2998 13.1048ZM9.09976 3.50479C8.43701 3.50479 7.89976 4.04204 7.89976 4.70479V8.30479C7.89976 8.96753 8.43701 9.50479 9.09976 9.50479C9.7625 9.50479 10.2998 8.96753 10.2998 8.30479V4.70479C10.2998 4.04204 9.7625 3.50479 9.09976 3.50479Z';

/* -------------------------------------------------------------------------- */
/* Constants                                                                   */
/* -------------------------------------------------------------------------- */

const ALERT_VIEWBOX_W = 23;
const ALERT_VIEWBOX_H = 21;
const ALERT_FILLED_VIEWBOX_W = 19;
const ALERT_FILLED_VIEWBOX_H = 17;

/**
 * Default fill for AlertFilledIcon.
 * Uses DS semantic warning token with palette fallback.
 */
export const ALERT_FILLED_ICON_DEFAULT_FILL = 'var(--ds-color-warning, var(--pal-orange-600, #F59E0B))';

/* -------------------------------------------------------------------------- */
/* Shared prop types                                                            */
/* -------------------------------------------------------------------------- */

const iconPropTypes = {
  /** Icon size in px — width and height scale proportionally. */
  size: PropTypes.number,
  /** Extra class names. */
  className: PropTypes.string,
  /**
   * Accessible label — when provided the icon is NOT hidden from assistive technology.
   * Use when the icon is the only content conveying meaning (no adjacent visible text).
   */
  'aria-label': PropTypes.string,
  /**
   * Override aria-hidden. Defaults to `true` (decorative).
   * Set to `false` only when pairing with aria-label above.
   */
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/* -------------------------------------------------------------------------- */
/* AlertIcon (outline)                                                          */
/* -------------------------------------------------------------------------- */

/**
 * Outline warning triangle. Color follows `currentColor` — set via CSS `color` property.
 * Decorative by default (`aria-hidden`). Pass `aria-label` to make it meaningful.
 */
const AlertIcon = ({
  size = 20,
  fill = 'currentColor',
  stroke = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = Math.round((size * ALERT_VIEWBOX_H) / ALERT_VIEWBOX_W);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${ALERT_VIEWBOX_W} ${ALERT_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={ALERT_PATH} fill={fill} stroke={stroke} />
    </svg>
  );
};

AlertIcon.propTypes = iconPropTypes;

/* -------------------------------------------------------------------------- */
/* AlertFilledIcon (filled)                                                     */
/* -------------------------------------------------------------------------- */

/**
 * Filled warning triangle. Uses DS semantic warning token by default.
 * Pass `fill="currentColor"` to inherit from CSS `color`, or any valid
 * SVG fill string: `"#B88817"`, `"var(--pal-red-600)"`, `"var(--ds-color-error)"`.
 */
const AlertFilledIcon = ({
  size = 20,
  fill = ALERT_FILLED_ICON_DEFAULT_FILL,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = Math.round((size * ALERT_FILLED_VIEWBOX_H) / ALERT_FILLED_VIEWBOX_W);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${ALERT_FILLED_VIEWBOX_W} ${ALERT_FILLED_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d={ALERT_FILLED_PATH} fill={fill} />
    </svg>
  );
};

AlertFilledIcon.propTypes = {
  ...iconPropTypes,
  /**
   * SVG fill value. Accepts any valid fill string.
   * Defaults to `--ds-color-warning` (DS semantic token).
   * Examples: `"currentColor"`, `"#B88817"`, `"var(--pal-red-600)"`.
   */
  fill: PropTypes.string,
};

/* -------------------------------------------------------------------------- */
/* Exports                                                                     */
/* -------------------------------------------------------------------------- */

export { AlertIcon, AlertFilledIcon };
export default AlertIcon;
